import './PaymentTooltip.scss';

function PaymentTooltip({ title, tooltipText }) {
  return (
    <span className="tooltiptext" data-testid={title}>
      <span>
        {title && (
          <span>
            <strong>{title}</strong>
            <br />
          </span>
        )}
        {tooltipText}
      </span>
    </span>
  );
}

export default PaymentTooltip;
